import {
  APPLY_NOW_SHELL_LABELS,
  AUTH_CONTENT,
} from '../constants/authContent'
import { CUSTOMER_SERVICE_PHONE_TEL } from '../constants/phone'
import { ApplyNowShell } from '../components/ApplyNowShell'
import { ApplyStepHeader } from '../components/ApplyStepHeader'

const copy = AUTH_CONTENT.applyNow.step4

/**
 * Mirrors Angular register `appliednoinfo` tab.
 * Content from AUTH_CONTENT; UI via presentational components.
 */
export function NeedToApplyFirst() {
  return (
    <ApplyNowShell labels={APPLY_NOW_SHELL_LABELS}>
      <ApplyStepHeader title={copy.title} />
      <p className="text-center text-sm leading-relaxed text-gray-600">
        {copy.description.split('{phone}').map((part, index, array) => (
          <span key={`phone-${index}`}>
            {part.split('{email}').map((subPart, subIndex, subArray) => (
              <span key={`email-${subIndex}`}>
                {subPart}
                {subIndex < subArray.length - 1 && (
                  <a
                    href={`mailto:${copy.email}`}
                    className="inline whitespace-nowrap font-semibold text-teal-dark underline hover:text-teal-darker"
                  >
                    {copy.email}
                  </a>
                )}
              </span>
            ))}
            {index < array.length - 1 && (
              <a
                href={`tel:${CUSTOMER_SERVICE_PHONE_TEL}`}
                className="inline whitespace-nowrap font-semibold text-teal-dark underline hover:text-teal-darker"
              >
                {copy.phone}
              </a>
            )}
          </span>
        ))}
      </p>
    </ApplyNowShell>
  )
}
